import React from 'react'

const WebProject = (props) => {
    return (
        <>
               <div className="col-md-6 mt-5 text-center on-hover-s ">
               <div className="project">
               <a href={props.webLink}>
            <img src={process.env.PUBLIC_URL + (props.img)} className={props.class}/> 
            <h4 className="text-center text-dark font-weight-bold">{props.web}</h4></a>
            </div>
                            </div>
        </>
    )
}

export default WebProject
